<table class="table table-sm">
  <thead>
    <tr>
      <th colspan="2">State</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Power</td>
      <td [@pulse]="mediaState()?.On">{{ mediaState()?.On }}</td>
    </tr>
    <tr>
      <td>Volume</td>
      <td [@pulse]="mediaState()?.Volume">{{ mediaState()?.Volume }}</td>
    </tr>
    <tr>
      <td>Type</td>
      <td [@pulse]="mediaState()?.CurrentlyPlayingTypeCode">{{ mediaState()?.CurrentlyPlayingTypeCode }}</td>
    </tr>
    <tr>
      <td>Code</td>
      <td [@pulse]="mediaState()?.CurrentlyPlayingCode">{{ mediaState()?.CurrentlyPlayingCode }}</td>
    </tr>
    <tr>
      <td>Muted</td>
      <td [@pulse]="mediaState()?.Muted">{{ mediaState()?.Muted }}</td>
    </tr>
    <tr>
      <td>Zone</td>
      <td [@pulse]="mediaState()?.Zone">{{ mediaState()?.Zone }}</td>
    </tr>
  </tbody>
</table>